import {useReducer, useState} from "react";
import userReducer from "../store/reducers/userReducer";
import * as ACTIONS from "../store/actions/userActions";
import {setErrors} from "../store/actions/errorsActions";
import {updateUser as sendUpdateUser} from "../services/user";
import toast from "react-hot-toast";

// Initial state values
const initialState = {
    users: [],
    user: {},
    loading: false,
    errors: null,
};

const useManageUser = () => {
    const [state, dispatch] = useReducer(userReducer, initialState);
    const [fetching, setFetching] = useState(false);
    const [user, setUser] = useState(state.user || initialState.user);

    // HANDLERS
    const handleUserChange = (event, type) => {
        const name = event?.target?.name;
        const value = event?.target?.value;

        switch (type) {
            case "user":
                setUser({...user, [name]: value});
                break;
            case "address":
                setUser({...user, address: {...user.address, [name]: value}});
                break;
            case "address_ukr":
                setUser({...user, address_ukr: {...user.address_ukr, [name]: value}});
                break;
            default:
                setUser({...user, [name]: value});
                break
        }
    }

    const handleUpdateUser = async (afterUpdateCallback) => {
        setFetching(true);
        try {
            const response = await sendUpdateUser(user);
            dispatch(ACTIONS.updateUser(response.data));

            if (typeof afterUpdateCallback === "function") {
                afterUpdateCallback();
            }
            toast.success('User updated successfully.');
        } catch (error) {
            console.error("Error updating user:", error);
            setUserError(error, "Failed to update user.");
            toast.error("Failed to update user.");
        } finally {
            setFetching(false);
        }
    };

    const setUserError = (err, msg) => {
        dispatch(setErrors('user', err, [msg]));
    };

    return {
        state,
        user,
        setUser,
        fetching,
        handleUserChange,
        handleUpdateUser,
        setUserError,
    };
};

export default useManageUser;
